/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import React from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { isNewWebSearchBackendEnabled } from 'reactApp/appHelpers/featuresHelpers';
import { BREAKPOINT_MD, BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { useWindowWidth } from 'reactApp/ui/VirtualList/VirtualList.hooks';
import { ESearchOptionSource } from 'reactApp/ui/WebSearch/WebSearch.data';
import { WebSearchSource } from 'reactApp/ui/WebSearch/WebSearchSource/WebSearchSource';

import styles from '../../DataListItemRow.css';
import newStyles from '../../DataListItemRow.new.css';
import { SearchItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox';
import { Date } from '../Date';
import { Destination } from '../Destination';
import { Download } from '../Download';
import { Expires } from '../Expires';
import { Favorite } from '../Favorite';
import { ItemName } from '../ItemName';
import { Pic } from '../Pic';
import { Publish } from '../Publish';
import { Search } from '../RowFor/Search';
import { Size } from '../Size';

const SearchItem = (props: SearchItemProps) => {
    const {
        isFolder,
        onCheckboxClick,
        isSelected,
        thumbUrl,
        kind,
        isVirus,
        ext,
        id,
        name,
        home,
        favoritesAvailable,
        isInFavorites,
        onFavorites,
        publicExpires,
        isAutoDelete,
        mtime,
        size,
        onDownload,
        storage,
        isPublic,
        onPublish,
    } = props;
    const path = home === '/' ? 'Облако' : home;
    const windowWidth = useWindowWidth();

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            variant1={<Search {...props} checkboxClassname={newStyles.check} favoriteClassname={newStyles.favoriteAction} />}
            control={
                <>
                    <Checkbox onCheckboxClick={onCheckboxClick} isSelected={isSelected} />
                    <Pic
                        isFolder={isFolder}
                        thumbUrl={thumbUrl}
                        kind={kind}
                        isVirus={!!isVirus}
                        ext={ext || ''}
                        id={id}
                        isAutoDelete={isAutoDelete}
                    />
                    {!ENABLE_FULL_RESPONSIVE ? (
                        <>
                            <ItemName name={name} ext={ext || ''} id={id} isRenameAvailable={props.renameAvailable} />
                            {isNewWebSearchBackendEnabled ? (
                                props.srchSrc === ESearchOptionSource.content &&
                                props.query && <WebSearchSource className={styles.source} query={props.query} />
                            ) : (
                                <Destination name={path} />
                            )}
                            <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
                            {isFolder ? <Expires expires={publicExpires} isAutoDelete={isAutoDelete} /> : <Date date={mtime} isWide />}
                            <Size size={size} />
                            <Download onClick={onDownload} ext={isFolder ? 'zip' : ext} size={size} id={id} storage={storage} />
                            <Publish onClick={onPublish} isActive={isPublic} />
                        </>
                    ) : (
                        <>
                            {windowWidth > BREAKPOINT_SM ? (
                                <>
                                    <ItemName name={name} ext={ext || ''} id={id} isRenameAvailable={props.renameAvailable} />
                                    {isNewWebSearchBackendEnabled ? (
                                        props.srchSrc === ESearchOptionSource.content &&
                                        props.query && <WebSearchSource className={styles.source} query={props.query} />
                                    ) : (
                                        <Destination name={path} />
                                    )}
                                </>
                            ) : (
                                <div className={styles.responsiveNameWrapper}>
                                    <ItemName name={name} ext={ext || ''} id={id} />
                                    {isNewWebSearchBackendEnabled ? (
                                        props.srchSrc === ESearchOptionSource.content &&
                                        props.query && <WebSearchSource className={styles.source} query={props.query} />
                                    ) : (
                                        <Destination name={path} noOverflow />
                                    )}
                                    <span className={styles.responsiveDateWrapper}>
                                        <Size size={size} />
                                        {!!mtime && <>&nbsp;•&nbsp;</>}
                                        <Date date={mtime} isWide />
                                    </span>
                                    <Expires expires={publicExpires} isAutoDelete={isAutoDelete} isShared={!!publicExpires} />
                                </div>
                            )}
                            {windowWidth > BREAKPOINT_MD && (
                                <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
                            )}
                            {windowWidth > BREAKPOINT_SM && (
                                <>
                                    {mtime && <Date date={mtime} isWide />}
                                    <Expires expires={publicExpires} isAutoDelete={isAutoDelete} isShared={!!publicExpires} />
                                    <Size size={size} />
                                </>
                            )}
                            <div className={styles.actionsWrapper}>
                                {windowWidth <= BREAKPOINT_MD && (
                                    <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
                                )}
                                <Download onClick={onDownload} ext={isFolder ? 'zip' : ext} size={size} id={id} storage={storage} />
                                <Publish onClick={onPublish} isActive={isPublic} />
                            </div>
                        </>
                    )}
                </>
            }
        />
    );
};

export default SearchItem;
